import { WarningIcon } from "../../Icons";
import clsx from "clsx";
import React from "react";
import { View } from "../../Base";
import { makeStyles } from "@mui/styles";
import { palette } from "../../../theme/palette";
import { useSelector } from "react-redux";
import { dutyAndOpportunityRoutesSelector } from "../../../reducers/matrixProfile/selectors";
import DutyPopover from "./DutyPopover";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    alignItems: "center",
  },
  infoIcon: {
    margin: "0 4px 0 15px",
    fill: palette.typography.white.high,
    cursor: "pointer",
  },
  warningIcon: {
    width: "16px",
    height: "14.45",
  },
  fillOrange: {
    fill: palette.orange,
  },
}));

const DutyWarningComponent = () => {
  const styles = useStyles();

  const [warningAnchorEl, setWarningAnchorEl] = React.useState(null);
  const dutyOpportunityRoutes = useSelector(dutyAndOpportunityRoutesSelector);

  return (
    <View className={styles.container}>
      <WarningIcon
        className={clsx(
          styles.infoIcon,
          styles.warningIcon,
          warningAnchorEl ? styles.fillOrange : null
        )}
        onClick={(event) =>
          dutyOpportunityRoutes?.duty?.length &&
          setWarningAnchorEl(event.currentTarget)
        }
      />
      {dutyOpportunityRoutes?.duty?.length || 0}

      <DutyPopover
        open={!!warningAnchorEl}
        onClose={() => setWarningAnchorEl(null)}
        anchorEl={warningAnchorEl}
      />
    </View>
  );
};

export default DutyWarningComponent;
